// extracted by mini-css-extract-plugin
module.exports = {"attendees_stats_container":"attendees_stats_attendees_stats_container__2Hyy8"};